import React from 'react';
import { Link, Image } from './common/NextAdapters';
import { cn } from '../lib/utils';
import { genreGradient } from '../lib/catalogue';

export function GenreTile({ category, sizes, compact = false, className }) {
  if (!category) return null;
  const slug = category.slug || category.id || category.Id;
  const name = category.name || category.Name;
  const count = category.count || category.MovieCount || 0;
  const image = category.image || category.ImageUrl;

  return (
    <Link
      href={`/browse?category=${slug}`}
      className={cn(
        'group/genre relative flex aspect-video items-end overflow-hidden rounded-xl ring-1 ring-white/10',
        'transition duration-300 hover:ring-white/30 hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none shadow-lg',
        className
      )}
      style={{ backgroundImage: genreGradient(category.id || category.Id || 0) }}
    >
      {image && (
        <Image
          src={image}
          alt={name}
          fill
          sizes={sizes}
          className="object-cover opacity-40 transition duration-500 group-hover/genre:scale-105 group-hover/genre:opacity-60"
        />
      )}

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

      <div className={cn('relative', compact ? 'p-3' : 'p-4 sm:p-5')}>
        <p className={cn('font-bold leading-tight text-white drop-shadow', compact ? 'text-sm' : 'text-base sm:text-lg')}>
          {name}
        </p>
        <p className={cn('mt-0.5 text-white/75 drop-shadow', compact ? 'text-xs' : 'text-xs sm:text-sm')}>
          {count} {count === 1 ? 'title' : 'titles'}
        </p>
      </div>
    </Link>
  );
}

export default GenreTile;
